import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Grid } from "@mui/material";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import MDBox from "components/MDBox";
import MDSnackbar from "components/MDSnackbar";
import BarHandler from "./components/BarHandler";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

function CreateNotification() {
  const { t } = useTranslation();

  const typesLabels = [
    {
      name: t("notifications.create.tabs.dataQuality"),
      value: "DataQuality"
    }
  ];
  const [selectedType, setSelectedType] = useState("DataQuality");

  const [successSB, setSuccessSB] = useState(false);
  const [errorSB, setErrorSB] = useState(false);
  const openSuccessSB = () => setSuccessSB(true);
  const closeSuccessSB = () => setSuccessSB(false);
  const openErrorSB = () => setErrorSB(true);
  const closeErrorSB = () => setErrorSB(false);

  function bringSuccessNotification() {
    return (
      <MDSnackbar
        color="success"
        icon="check"
        title={t("notifications.create.success.title")}
        content={t("notifications.create.success.content")}
        dateTime={new Date().toLocaleTimeString()}
        open={successSB}
        onClose={closeSuccessSB}
        close={closeSuccessSB}
        bgWhite
      />
    );
  }

  function bringErrorNotification() {
    return (
      <MDSnackbar
        color="error"
        icon="warning"
        title={t("notifications.create.error.title")}
        content={t("notifications.create.error.content")}
        dateTime={new Date().toLocaleTimeString()}
        open={errorSB}
        onClose={closeErrorSB}
        close={closeErrorSB}
        bgWhite
      />
    );
  }

  return (

    <DashboardLayout>
      <MDBox mt={4} p={0}>
        <Grid container spacing={3}>
          <Grid item lg={12} xl={9}>
            <Tabs orientation={"horizontal"} value={selectedType} onChange={(e, val) => { setSelectedType(val) }} style={{}}>
              {typesLabels.map((item, index) => {
                return <Tab key={index} label={item.name} value={item.value} style={{ padding: '15px' }} />
              })}
            </Tabs>
            <BarHandler type={selectedType} setSuccessSB={setSuccessSB} setErrorSB={setErrorSB}/>
          </Grid>
        </Grid>
      </MDBox>
      {successSB && bringSuccessNotification()}
      {errorSB && bringErrorNotification()}
    </DashboardLayout>
  );
}

export default CreateNotification;

// <CreateAlertPanel open={open} handleClose={handleClose} setSuccessSB={setSuccessSB} setErrorSB={setErrorSB} />
